export default function Card(props){
    return (
        <div className='p-3 bg-white border rounded shadow h-100'>
            {props.children}
        </div>
    )
}